import { DatePickerDesignTokens } from '@primeuix/themes/aura/datepicker';

export const datePickerTokens: DatePickerDesignTokens = {
  panel: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
    shadow: '{overlay.popover.shadow}',
    padding: '{overlay.popover.padding}',
  },
  header: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    color: '{content.color}',
    padding: '0 0 0.5rem 0',
  },
  title: {
    gap: '0.5rem',
    fontWeight: '500',
  },
  dropdown: {
    width: '2.5rem',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.border.color}',
    activeBorderColor: '{form.field.border.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    sm: {
      width: '2rem',
    },
    lg: {
      width: '3rem',
    },
  },
  inputIcon: {
    color: '{form.field.icon.color}',
  },
  selectMonth: {
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    color: '{content.color}',
    padding: '0.25rem 0.5rem',
    borderRadius: '{content.border.radius}',
  },
  selectYear: {
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    color: '{content.color}',
    padding: '0.25rem 0.5rem',
    borderRadius: '{content.border.radius}',
  },
  group: {
    borderColor: '{content.border.color}',
    gap: '{overlay.popover.padding}',
  },
  dayView: {
    margin: '0.5rem 0 0 0',
  },
  weekDay: {
    padding: '0.25rem',
    fontWeight: '500',
    color: '{content.color}',
  },
  date: {
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    selectedBackground: '{primary.color}',
    selectedColor: '{primary.contrast.color}',
    rangeSelectedBackground: '{highlight.background}',
    rangeSelectedColor: '{highlight.color}',
    color: '{content.color}',
    width: '2rem',
    height: '2rem',
    borderRadius: '{datepicker.date.width} / 2',
    padding: '0.25rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  monthView: {
    margin: '0.5rem 0 0 0',
  },
  month: {
    borderRadius: '{content.border.radius}',
    padding: '0.375rem',
  },
  yearView: {
    margin: '0.5rem 0 0 0',
  },
  year: {
    borderRadius: '{content.border.radius}',
    padding: '0.375rem',
  },
  buttonbar: {
    padding: '0.5rem 0 0 0',
    borderColor: '{content.border.color}',
  },
  timePicker: {
    padding: '0.5rem 0 0 0',
    borderColor: '{content.border.color}',
    gap: '0.5rem',
    buttonGap: '0.25rem',
  },
  colorScheme: {
    light: {
      dropdown: {
        background: '{surface.100}',
        hoverBackground: '{surface.200}',
        hoverColor: '{surface.700}',
        activeBackground: '{surface.300}',
        activeColor: '{surface.800}',
        color: '{surface.600}',
      },
      today: {
        background: '{surface.200}',
        color: '{surface.900}',
      },
    },
    dark: {
      dropdown: {
        background: '{primary.950}',
        hoverBackground: '{primary.900}',
        hoverColor: '{surface.200}',
        activeBackground: '{primary.800}',
        activeColor: '{surface.200}',
        color: '{surface.200}',
      },
      today: {
        background: '#282648',
        color: '{surface.200}',
      },
      date: {
        rangeSelectedBackground: '{primary.900}',
      },
    },
  },
};
